<script lang="ts" setup>
import { ref } from 'vue';

import { KaButton } from '@/kasten-components/components/KaButton';
import type { MaybePromise } from '@/kasten-components/types';

import { injectMultiStepFormContext, type Step } from './model';

const {
  onLast: onTriggerLast,
  isFirstStep,
  isLastStep,
  currentStep,
  nextStep,
} = injectMultiStepFormContext();

const props = defineProps<{
  onJump: (currentStep: Step, nexStep?: Step) => MaybePromise<boolean>;
}>();

const loading = ref(false);

const handleClick = async () => {
  loading.value = true;
  if (await props.onJump(currentStep.value, nextStep.value)) {
    onTriggerLast();
  }
  loading.value = false;
};
</script>
<template>
  <KaButton
    variant="primary"
    class="max-sm:flex-grow"
    :loading="loading"
    data-testid="multiStepNext"
    @click="handleClick"
  >
    <slot :loading="loading" :last-step="isLastStep" :first-step="isFirstStep">Jump to last</slot>
  </KaButton>
</template>
